import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { UpdateRoomMaintenanceForm } from "../schema/UpdateRoomMaintenanceSchema";
import UpdateRoomMaintenanceResponse from "../response/UpdateRoomMaintenanceResponse";

export const useUpdateRoomMaintenance = () => {
    return useMutation({
        mutationFn: async (values: {
            id: string;
            formData: UpdateRoomMaintenanceForm;
        }) => privateApi.put(`/v4/room-maintenance/${values.id}`, values.formData),
        onSuccess: async (response) => {
            try {
                const validationResult = UpdateRoomMaintenanceResponse.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid update room maintenance data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update room maintenance', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid room maintenance data format");
            } else {
                console.error('Failed to update room maintenance', error);
                throw error;
            }
        },
    });
};